<div class="progress-container">
  <mat-progress-bar [value]="tempoFinalizar" mode="determinate"
    [ngStyle]="{ '--mdc-linear-progress-active-indicator-color': getCorPrazo(tempoFinalizar), 'width': width, 'height': height }">
  </mat-progress-bar>
  <p class="centered-text weigth-500" style="white-space: nowrap;" [style.font-size]="font" [ngStyle]="{ 'color': getCorLabel(tempoFinalizar), 'left': left }">{{ data }}</p>
</div>
